import { withTheme } from '../config';
import { Overlay } from '@rneui/base/dist/Overlay/Overlay';
export { Overlay };
export default withTheme(Overlay, 'Overlay');
